import { createApi, retry } from '@reduxjs/toolkit/query/react';
import { HYDRATE } from 'next-redux-wrapper';
import { fetchQuery } from './helpers/fetchQuery';

export const contactsApi = createApi({
  reducerPath: 'contactsApi',
  tagTypes: ['ContactCount'],
  baseQuery: retry(fetchQuery({ basePath: '/api/v3', subDomain: 'contacts.api' }), {
    maxRetries: 1
  }),
  extractRehydrationInfo(action, { reducerPath }): any {
    if (action.type === HYDRATE) {
      return action.payload[reducerPath];
    }
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  endpoints: builder => ({})
});
